<template>
	<section class="member-settings">
		<el-card shadow="never">
			<div slot="header">
				偏好设置
			</div>
			<el-form label-width="120px" :model="preferences">
				<el-form-item label="界面语言">
					<el-select v-model="preferences.locale">
						<el-option label="简体中文" value="zh-CN" />
						<el-option label="English" value="en-US" />
					</el-select>
				</el-form-item>
				<el-form-item label="默认币种">
					<el-select v-model="preferences.currency">
						<el-option label="人民币 CNY" value="CNY" />
						<el-option label="美元 USD" value="USD" />
						<el-option label="欧元 EUR" value="EUR" />
					</el-select>
				</el-form-item>
				<el-form-item label="常用出发地">
					<el-input
						v-model="preferences.origin"
						placeholder="例如：PEK / 北京首都"
					/>
				</el-form-item>
				<el-form-item label="通知偏好">
					<el-checkbox-group v-model="preferences.notifications">
						<el-checkbox label="邮件" />
						<el-checkbox label="短信" />
						<el-checkbox label="企业微信" />
					</el-checkbox-group>
				</el-form-item>
				<el-form-item>
					<el-button type="primary">
						保存
					</el-button>
					<el-button>
						重置
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</section>
</template>

<script>
export default {
	name: 'MemberSettings',
	data() {
		return {
			preferences: {
				locale: 'zh-CN',
				currency: 'CNY',
				origin: 'PEK',
				notifications: ['邮件', '企业微信']
			}
		}
	}
}
</script>

